import React from "react";
import { LuShieldAlert } from "react-icons/lu";

const NoAccessScreen = () => {
  return (
    <div className="min-h-screen w-full bg-gradient-to-b from-[#F8FAFB] to-white px-4 flex items-center justify-center">
      <div className="w-full max-w-lg">
        <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-6 sm:p-8 text-center">
          <div className="w-12 h-12 rounded-2xl bg-red-50 text-red-600 flex items-center justify-center mx-auto mb-4">
            <LuShieldAlert size={26} />
          </div>

          <h1 className="text-2xl font-semibold text-gray-900 mb-2">
            Access restricted
          </h1>
          <p className="text-gray-600">
            You don&apos;t have access to any modules in this application. Please
            contact your administrator or support to enable access.
          </p>
        </div>

        <p className="text-center text-xs text-gray-400 mt-4">
          If you believe this is a mistake, ask an administrator to update your
          module permissions.
        </p>
      </div>
    </div>
  );
};

export default NoAccessScreen;
